import { findValue } from "./utils";
export const getDisplayLabel = ({ options, placeholder, renderSelectedOption, selectedValue, selectedOption }) => {
    if (renderSelectedOption) {
        return renderSelectedOption(selectedOption, options, selectedValue);
    }
    const foundOption = options && selectedValue !== undefined && findValue(selectedValue, options);
    const matchingOptionLabel = foundOption ? foundOption.label : undefined;
    if (matchingOptionLabel) {
        if (typeof matchingOptionLabel === "function") {
            return matchingOptionLabel({ searchText: undefined });
        }
        return matchingOptionLabel;
    }
    if (selectedOption) {
        if (typeof selectedOption.label === "function") {
            return selectedOption.label({ searchText: undefined });
        }
        return selectedOption.label;
    }
    return placeholder || "";
};
